















import { Component, Vue } from "vue-property-decorator";
import StoreManage from "@/views/storeManage/index.vue";
import StoreManageKA from "@/views/storeManageKA/index.vue";

@Component({
  components: {
    StoreManage,
    StoreManageKA
  }
})
export default class StoreManageIndex extends Vue {
  tabList: any[] = [
    { value: "0", label: "门店管理" },
    { value: "1", label: "门店管理-KA" }
  ];
  activeName: string = "0";
}
